module.exports = __webpack_public_path__ + "static/media/dSPACE_Logo.33be1a89.png";